import {Router} from '@angular/router';
import {Store} from '@ngrx/store';

import {PricingService} from '../pricing.service';
import {PaymentService} from '../payment.service';

import {map, switchMap, tap, catchError, mergeMap, withLatestFrom} from 'rxjs/operators';
import {of} from 'rxjs';

import * as PaymentActions from './payment.actions';
import * as ErrorActions from '../../error/store/error.actions';
import * as fromApp from '../../store/app.reducers';
import * as UserActions from '../../user/store/user.actions';

import {HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {createEffect, Actions, ofType} from '@ngrx/effects';
import {Price} from '../price.model';
import { Stripe } from '@stripe/stripe-js';
import {StripeProviderServiceService} from '../stripe-provider-service.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from 'ngx-toastr';

@Injectable()
export class PaymentEffects {

  getPricing = createEffect(() => this.actions$
    .pipe(
      ofType(PaymentActions.GET_PRICING),
      switchMap(
        (state: {type: string, payload: {params: any}}) => {
          return this.pricingService.getPricing(state.payload.params).pipe(
            map(
              (response: Price[]) => {
                const res = response;
                let check = false;
                (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor);
                if (check) {
                  res.sort((a, b) => {
                    if (a.status > b.status) {
                        return -1;
                    } else {
                        return 1;
                    }
                  });
                }
                return {
                  type: PaymentActions.SET_PRICING,
                  payload: res
                };
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  getPricingTime = createEffect(() => this.actions$
    .pipe(
      ofType(PaymentActions.GET_PRICING_TIME),
      switchMap(
        (state: {type: string, payload: {params: any}}) => {
          this.store.dispatch(
            new PaymentActions.SetPaymentLoader({
              name: 'loadingPricing',
              value: true
            })
          );
          return this.pricingService.getPricingTime(state.payload.params).pipe(
            map(
              (response: any[]) => {
                this.store.dispatch(
                  new PaymentActions.SetPaymentLoader({
                    name: 'loadingPricing',
                    value: false
                  })
                );
                return {
                  type: PaymentActions.SET_PRICING_TIME,
                  payload: response
                };
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  getPricingProfile = createEffect(() => this.actions$
    .pipe(
      ofType(PaymentActions.GET_PRICING_PROFILE),
      switchMap(
        (state: {type: string, payload: number}) => {
          this.store.dispatch(
            new PaymentActions.SetPaymentLoader({
              name: 'loadingPricing',
              value: true
            })
          );
          return this.pricingService.getPriceProfile(state.payload).pipe(
            map(
              (response: Price[]) => {
                const res = response;
                this.store.dispatch(
                  new PaymentActions.SetPaymentLoader({
                    name: 'loadingPricing',
                    value: false
                  })
                );
                return {
                  type: PaymentActions.SET_PRICING_PROFILE,
                  payload: res
                };
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  getPrice = createEffect(() => this.actions$
    .pipe(
      ofType(PaymentActions.GET_PRICE),
      map(
        (data: {type: string, payload: number}) => {
          return data.payload;
        }
      ),
      switchMap(
        (id: number) => {
          return this.pricingService.getPrice(id).pipe(
            map(
              (response: Price) => {
                return {
                  type: PaymentActions.SET_PRICE,
                  payload: response
                };
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  createPayment = createEffect(() => this.actions$
    .pipe(
      ofType(PaymentActions.CREATE_PAYMENT),
      map(
        (data: {type: string, payload: number}) => {
          return data.payload;
        }
      ),
      switchMap(
        (id: number) => {
          return this.paymentService.createPayment(id).pipe(
            tap(
              (response: any) => {
                if (response.code === 301) {
                  window.location.replace(response.redirect_url);
                }
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  createPaymentStripe = createEffect(() => this.actions$
    .pipe(
      ofType(PaymentActions.CREATE_PAYMENT_STRIPE),
      map(
        (data: {type: string, payload: {
            id: number,
            token: string
          }}) => {
          return data.payload;
        }
      ),
      switchMap(
        (params: {id: number, token: string}) => {
          return this.paymentService.createPaymentStripe(params.id, params.token).pipe(
            mergeMap(
              (response: any) => {
                const actions = [];
                if (response.paid === true && response.status === 'succeeded') {
                  this.router.navigate(['/payment/success', response.id]);
                  actions.push({
                    type: PaymentActions.SET_PAYMENT_LOADER,
                    payload: {name: 'pay', value: false}
                  });
                } else {
                  this.notifierService.error('Something went wrong, try again');
                }

                return actions;
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                this.store.dispatch(
                  new PaymentActions.SetPaymentLoader({
                    name: 'pay',
                    value: false
                  })
                );
                if (err.status === 500) {
                  this.notifierService.error(err.error.message);
                }
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  createPaymentSubscriptionStripe = createEffect(() => this.actions$
    .pipe(
      ofType(PaymentActions.CREATE_PAYMENT_SUBSCRIPTION_STRIPE),
      map(
        (data: {type: string, payload: {
            id: number,
            params: any
          }}) => {
          return data.payload;
        }
      ),
      withLatestFrom(this.stripeProviderService.loadStripe()),
      switchMap(
        (state: [{id: number, params: any}, Stripe]) => {
          const params = state[0];
          const stripe = state[1];
          this.store.dispatch(
            new PaymentActions.SetPaymentLoader({
              name: 'pay',
              value: true
            })
          );
          return this.paymentService.createPaymentSubscriptionStripe(params.id, params.params).pipe(
            tap(
              (response: any) => {
                const actions = [];
                const redirectToCheckout = response.redirect;
                if (redirectToCheckout) {
                  const sessionId = response.session.id;
                  this.store.dispatch(
                    new PaymentActions.SetPaymentLoader({
                      name: 'pay',
                      value: false
                    })
                  );

                  return stripe.redirectToCheckout({
                    sessionId: sessionId
                  });
                } else {
                  const orderId = response.order.id;
                  this.store.dispatch(
                    new PaymentActions.SetPaymentLoader({
                      name: 'pay',
                      value: false
                    })
                  );
                  this.router.navigate(['/payment/success', orderId]);
                }
                this.modalService.dismissAll();

              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                this.store.dispatch(
                  new PaymentActions.SetPaymentLoader({
                    name: 'pay',
                    value: false
                  })
                );
                if (err.status === 500) {
                  this.notifierService.error(err.error.message);
                }
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  getPaymentDetail = createEffect(() => this.actions$
    .pipe(
      ofType(PaymentActions.GET_PAYMENT_DETAIL),
      map(
        (data: {type: string, payload: number}) => {
          return data.payload;
        }
      ),
      switchMap(
        (id: number) => {
          return this.paymentService.getPaymentDetail(id).pipe(
            mergeMap(
              (response: Price) => {
                return [{
                  type: PaymentActions.SET_PAYMENT_DETAIL,
                  payload: response
                },{
                  type: UserActions.GET_ACTUAL_USER
                }];
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  trackFacebookConversion = createEffect(() => this.actions$
    .pipe(
      ofType(PaymentActions.TRACK_FACEBOOK_CONVERSION),
      map(
        (data: {type: string, payload: number}) => {
          return data.payload;
        }
      ),
      switchMap(
        (orderId: number) => {
          return this.paymentService.trackFacebookConversion(orderId).pipe(
            map(
              () => {
                return {type: 'NO_ACTION'};
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                console.error('Facebook conversion tracking failed', err);
                return of({type: 'NO_ACTION'});
              }
            )
          );
        }
      )
    ), {dispatch: false}
  );

  constructor(
    private actions$: Actions,
    private pricingService: PricingService,
    private paymentService: PaymentService,
    private router: Router,
    private notifierService: ToastrService,
    private store: Store<fromApp.AppState>,
    private stripeProviderService: StripeProviderServiceService,
    private modalService: NgbModal

  ) {}
}
